enum FuncaoEnum {
  cirurgiao = 0,
  primeiroAuxiliar = 1,
  segundoAuxiliar = 2,
  terceiroAuxiliar = 3,
  quartoAuxiliar = 4,
  instrumentador = 5,
  anestesista = 6,
}

export default FuncaoEnum
